// top menu page
import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, bindActionCreators } from 'redux';
import { connect, Provider } from 'react-redux';
import TopMenuReducer from '../../reducers/top_menu.reducers';
import * as TopMenuActions from '../../actions/top_menu.actions';
import TopMenuApp from './top_menu';
import { getTopMenuKey } from '../../../utils/common';

const mapsStateToPropsTopMenu = (state) => ({
  topMenuData: state,
});

const mapsDispatchToPropsTopMenu = (dispatch) => ({
  actions: bindActionCreators(TopMenuActions, dispatch),
});

const TopMenuAppComp = connect(mapsStateToPropsTopMenu, mapsDispatchToPropsTopMenu)(TopMenuApp);

let topMenuStore;
const initTopMenuAppComp = (data) => {
  // console.log('initTopMenuAppComp----->');
  // console.log(data);
  const mountId = document.getElementById('top-menu-nav');
  topMenuStore = createStore(TopMenuReducer, data);
  if (mountId) {
    ReactDOM.render(
      <Provider store={topMenuStore}>
        <TopMenuAppComp />
      </Provider>,
      mountId,
    );
  }
}

const topMenuModel = {
  activeMenuItem: (args) => {
    if (typeof args.menuName !== 'undefined' && typeof topMenuStore !== 'undefined') {
      topMenuStore.dispatch(TopMenuActions.updateActiveMenu(args.menuName));
      if (typeof activeLeftMenuId === 'function' && args.menuName) {
        activeLeftMenuId(args.menuName);
      }
    }
  },
  deleteMenuItem: (values) => {
    const key = getTopMenuKey(values.key);
    if (typeof topMenuStore !== 'undefined') {
      topMenuStore.dispatch(
        TopMenuActions.topmenuDeleteObject(key, values.object_id, values.object_type)
      );
    }
  },
  favoriteMenuItem: (values) => {
    const key = getTopMenuKey(values.obj_type);
    if (key === 'mywork' && typeof topMenuStore !== 'undefined') {
      topMenuStore.dispatch(
        TopMenuActions.updateFavorites(key, values.data, values.pinAction)
      );
    }
  },
  updateMenuRecentItem: (data) => {
    const key = getTopMenuKey(data.object_type);
    if (typeof topMenuStore !== 'undefined') {
      topMenuStore.dispatch(TopMenuActions.updateTopMenuRecentItems(
        key,
        data.object_id,
        data.object_type,
        data.object_name, 
        data.actionType
      ));
    }
  },
  updateMenuItem: (data) => {
    const key = getTopMenuKey(data.object_type);
    if (typeof topMenuStore !== 'undefined') {
      topMenuStore.dispatch(TopMenuActions.updateTopMenuObjectName(
        key,
        data.object_id,
        data.object_type,
        data.object_name
      ));
    }
  },
  updateMenuItemPageTitle: (data) => {
    const key = getTopMenuKey(data.object_type);
    if (typeof topMenuStore !== 'undefined') {
      topMenuStore.dispatch(
        TopMenuActions.updateMenuItemPageTitle(key, data.title)
      );
    }
  },
  reloadMenuItems: (values) => {
    if (typeof topMenuStore !== 'undefined') {
      topMenuStore.dispatch(
        TopMenuActions.dumbTheTopMenu(values.keyTop, values.topmenuFavorites)
      );
    }
  },
  updateMenuButton: (data) => {
    const key = getTopMenuKey(data.object_type);
    if (typeof topMenuStore !== 'undefined') {
      topMenuStore.dispatch(TopMenuActions.updateTopMenuBottomMenuButton(
        key,
        data.object_type,
        data.showMenu
      ));
    }
  }
};
window.topMenuModel = Object.create(topMenuModel);
window.initTopMenuAppComp = initTopMenuAppComp;
